import React from "react";
import { connectHits } from "react-instantsearch/connectors";
import getClassification from "../../utils/getClassification";
import ensurePgaSuffix from "../../utils/ensurePgaSuffix";
import Cards from "./Cards";

const patchHighlightValue = (value, memberTypeLabel) => {
  if (!value) return value;
  const stripped = value.replace(/<\/?ais-highlight-\d+>/g, "");
  if (ensurePgaSuffix(stripped, memberTypeLabel) === stripped) return value;
  return `${value}, PGA`;
};

const withPgaSuffix = (hit) => {
  const { member_type_label, profile_name, _highlightResult } = hit;
  const fixedName = ensurePgaSuffix(profile_name, member_type_label);
  if (fixedName === profile_name) return hit;

  const fixedHighlight =
    _highlightResult && _highlightResult.profile_name
      ? {
          ..._highlightResult,
          profile_name: {
            ..._highlightResult.profile_name,
            value: patchHighlightValue(
              _highlightResult.profile_name.value,
              member_type_label
            ),
          },
        }
      : _highlightResult;

  return {
    ...hit,
    profile_name: fixedName,
    _highlightResult: fixedHighlight,
  };
};

const RenderResults = ({ hit }) => {
  const patchedHit = withPgaSuffix(hit);
  return (
    <Cards
      {...{
        hit: patchedHit,
        key: patchedHit.universal_id,
        classification: getClassification(patchedHit),
      }}
    />
  );
};

export default connectHits(RenderResults);
